// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-oasis -> rebel-residential-oasis -> oasis
// Generated: 2026-09-11T19:03:03.058Z
// Counts: 0 design, 6 content, 6 slot group, 0 collection binding, 5 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactblock.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "tourblock.form_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>We'd love to hear from you!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "propertyoverview.front_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "manualfloorplans.plan_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-3a83-702e-bcde-7c07f91a379c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "S1 studio floor plan, 567 sq ft, 1 bath"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "S1 0x1 567 SF-FP"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "0"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "567"
      }
    }
  },
  "manualfloorplans.plan_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-3a7e-779d-8f4c-cf070447f3ae.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A2 one-bedroom floor plan, 668 sq ft, 1 bath"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "A2 1x1 668 SF-FP"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "668"
      }
    }
  },
  "manualfloorplans.plan_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-3a20-744b-8bc9-6902c83c15c1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "B1 two-bedroom, two-bath floor plan, 1,056 sq ft"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "B1 2x2 1056 SF-FP"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1056"
      }
    }
  },
  "manualfloorplans.plan_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167733/01a03a30-5062-708e-9316-b63ecb7b64fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "C1 three-bedroom, two-bath floor plan, 1,516 sq ft"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "C1 3x2 1516 SF-FP"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "3"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1516"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
